/**
 * Analytics utility — GA4 integration for SPA (React Router)
 * Uses native `arguments` object to avoid gtag.js scope issues with spread operators.
 * 
 * ENV: REACT_APP_GA_MEASUREMENT_ID=G-XXXXXXXXXX
 */

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || '';
let isInitialized = false;

export const initGA = () => {
  if (isInitialized || typeof window === 'undefined') return;
  if (!GA_MEASUREMENT_ID || GA_MEASUREMENT_ID === 'G-XXXXXXXXXX') {
    console.warn('[Analytics] GA Measurement ID ausente. Defina REACT_APP_GA_MEASUREMENT_ID no .env');
    return;
  }

  const existing = document.querySelector(`script[src*="googletagmanager.com/gtag/js"]`);
  if (existing) { isInitialized = true; return; }

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  // CRITICAL: Must use native `arguments` — spread operator breaks gtag internals
  // eslint-disable-next-line prefer-rest-params, no-unused-vars
  window.gtag = function () { window.dataLayer.push(arguments); };

  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });

  isInitialized = true;
};

export const trackPageView = (path, title) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', 'page_view', {
    page_path: path,
    page_title: title,
    page_location: window.location.href,
  });
};

export const trackEvent = (action, category, label, value) => {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', action, {
    event_category: category,
    event_label: label,
    ...(value !== undefined && { value }),
  });
};

// ─── Conversion helpers ──────────────────────────────────────────────────────
export const trackSignUp = (plan = 'free') => {
  trackEvent('sign_up', 'Acquisition', plan);
};

export const trackTrialStart = (toolName = 'platform', trialDays = 14) => {
  trackEvent('start_trial', 'Acquisition', toolName, trialDays);
};

export const trackFeatureUse = (featureName) => {
  trackEvent('feature_use', 'Engagement', featureName);
};
